import { busbar_registry } from "./busbar_registry";

export const generate_busbar_locations_demo = () => {
    return busbar_registry.map(loc => ({
        id: loc.location_id,
        location: loc.location,
    }));
};